import { createContext } from 'react'

export const CreateProjectContext = createContext({})

export default CreateProjectContext
